import { Configuration } from '@azure/msal-browser';

export function buildMsalConfig(clientId: string, tenantId: string): Configuration {
    return {
        auth: {
            clientId,
            authority: `https://login.microsoftonline.com/${tenantId}`,
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
        },
    };
}

export function buildLoginRequest(clientId: string): { scopes: string[] } {
    return {
        scopes: ['openid', 'profile', 'offline_access', `api://${clientId}/chat.access`],
    };
}
